import type { CharterInventoryManagementParams } from '~/services/CharterService';

export const charterInventoryManagementQueryKeys = {
  all: ['flights-charter', 'inventory-management'] as const,
  list: (params: CharterInventoryManagementParams) => [...charterInventoryManagementQueryKeys.all, params] as const,
};
